import React from "react";
import "./FullWidthImage.scss";

export default function FullWidthImage({ src, alt }) {
  return (
    <div className="full-width-image">
      <img
        src={src}
        alt={alt || "Portfolio showcase"}
        loading="lazy" // 👈 Lazy load the image
      />
    </div>
  );
}
